/**
 * The pinned top of every checkout step: progress, then what this step asks.
 *
 * Pinned rather than scrolled away with the body, so a donor half-way down a
 * long step still knows where they are in the flow — and so the five steps
 * open identically instead of each laying out its own heading.
 */

import { memo } from 'react';
import { StyleSheet, View } from 'react-native';

import { space } from '../../theme';
import { CheckoutStepper } from './CheckoutStepper';
import { ScreenTitle } from '../layout/ScreenTitle';

export interface CheckoutHeaderProps {
  /** Index of the active step in `steps`. */
  current: number;
  /** The flow's steps; a donation's by default. */
  steps?: readonly string[];
  /**
   * Omitted where it would only repeat the stepper's active label: an empty
   * green band saying "Distribution Detail" under a stepper already reading
   * "Distribution Detail" is chrome twice over.
   */
  title?: string;
  subtitle?: string;
}

export const CheckoutHeader = memo(function CheckoutHeader({
  current,
  steps,
  title,
  subtitle,
}: CheckoutHeaderProps) {
  return (
    <View testID="checkout-header">
      {/* The shell's sub-header already pads the top; the stepper's own would
          double it and push the first card below the fold on a short phone. */}
      <CheckoutStepper current={current} steps={steps} style={styles.stepper} />
      {title ? <ScreenTitle title={title} subtitle={subtitle} /> : null}
    </View>
  );
});

const styles = StyleSheet.create({
  stepper: {
    paddingTop: 0,
    paddingBottom: space.md,
  },
});
